import { useQuery } from "@tanstack/react-query";
import { api, assetUrl } from "@/lib/api";
import { COUNTRY_PHOTOS, REGION_PHOTOS } from "@/data/site";

export const PHOTOS_QUERY = ["photo-overrides"];
export const fetchPhotos = () => api.get("/photos").then((r) => (r.data && typeof r.data === "object" ? r.data : {}));

// Admin-uploaded photos override the built-in defaults; falls back silently if the API is unreachable.
export function usePhotos() {
  const { data } = useQuery({
    queryKey: PHOTOS_QUERY,
    queryFn: fetchPhotos,
    staleTime: 60_000,
  });
  const map = data ?? {};
  return {
    country: (name) => assetUrl(map[`country:${name}`]) || COUNTRY_PHOTOS[name],
    region: (slug) => assetUrl(map[`region:${slug}`]) || REGION_PHOTOS[slug]?.[0],
    isCustom: (key) => Boolean(map[key]),
  };
}
